import data from './data.json';
import groups from './groups.json';

export const defaqtoSourceData = {
  ...data,
  groups
};
